export default "__VITE_ASSET__WvDxeER3__"